(() => {
  if (window.__ltReorderInit) return;
  window.__ltReorderInit = true;

  const setState = (button, state, message = '') => {
    const card = button.closest('.lt-p0-reorder-card, .lt-p0-reorder-action');
    const error = card?.querySelector('[data-lt-reorder-error]');
    if (error) {
      error.textContent = message;
      error.hidden = !message;
    }
    button.classList.toggle('loading', state === 'loading');
    button.disabled = state === 'loading';
  };

  const jsUrl = (url) => (url.endsWith('.js') ? url : `${url}.js`);

  const createAttemptId = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `lt-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  };

  const getSummary = (items) => ({
    lineCount: items.length,
    quantity: items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0)
  });

  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const checker = privacy?.analyticsProcessingAllowed;
      return typeof checker === 'function' && checker.call(privacy) === true;
    } catch (_) {
      return false;
    }
  };

  const publishEvent = (name, payload) => {
    if (!analyticsAllowed()) return;

    try {
      const publish = window.Shopify?.analytics?.publish;
      if (typeof publish !== 'function') return;
      const result = publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {
      // Analytics must never interrupt reorder flow.
    }
  };

  const eventPayload = (button, items, attemptId) => {
    const summary = getSummary(items);
    return {
      attempt_id: attemptId,
      origin_order_id: button.dataset.orderId || '',
      origin_order_name: button.dataset.orderName || '',
      context: button.dataset.context || 'order',
      line_count: summary.lineCount,
      quantity: summary.quantity,
      tracking_version: '2'
    };
  };

  const writeAttribution = async (button, items, attemptId) => {
    const variantIds = [...new Set(items.map((item) => String(item.id)).filter(Boolean))];
    const summary = getSummary(items);
    const baseUrl = window.routes?.cart_update_url || '/cart/update';
    const response = await fetch(jsUrl(baseUrl), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          __lt_reorder: '1',
          __lt_reorder_attempt_id: attemptId,
          __lt_reorder_origin_order_id: button.dataset.orderId || '',
          __lt_reorder_origin_order_name: button.dataset.orderName || '',
          __lt_reorder_context: button.dataset.context || 'order',
          __lt_reorder_variant_ids: variantIds.join(','),
          __lt_reorder_line_count: String(summary.lineCount),
          __lt_reorder_quantity: String(summary.quantity),
          __lt_reorder_tracking_version: '2',
          __lt_reorder_at: new Date().toISOString()
        }
      })
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lt-reorder]');
    if (!button || button.disabled) return;

    let items;
    try {
      items = JSON.parse(button.dataset.items || '[]');
    } catch (_) {
      setState(button, 'error', 'Naročila ni bilo mogoče pripraviti za ponovitev.');
      return;
    }

    if (!Array.isArray(items) || !items.length) return;

    const attemptId = createAttemptId();
    const trackingPayload = eventPayload(button, items, attemptId);
    setState(button, 'loading');
    publishEvent('lacnetacke:reorder_started', trackingPayload);

    try {
      const baseUrl = window.routes?.cart_add_url || '/cart/add';
      const response = await fetch(jsUrl(baseUrl), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Izdelkov ni bilo mogoče dodati v košarico.');
      }

      let attributionWritten = false;
      try {
        await writeAttribution(button, items, attemptId);
        attributionWritten = true;
        publishEvent('lacnetacke:reorder_cart_ready', trackingPayload);
      } catch (error) {
        console.warn('[LT reorder] Attribution update failed', error);
        publishEvent('lacnetacke:reorder_attribution_failed', {
          ...trackingPayload,
          stage: 'cart_attribution'
        });
      }

      if (!attributionWritten) {
        console.warn('[LT reorder] Reorder completed without persistent order attribution.');
      }

      window.location.assign(window.routes?.cart_url || '/cart');
    } catch (error) {
      publishEvent('lacnetacke:reorder_failed', {
        ...trackingPayload,
        stage: 'cart_add'
      });
      setState(button, 'error', error.message || 'Izdelkov ni bilo mogoče dodati v košarico.');
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
})();